"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var ReactionsFooter = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: calc(100% - ", "px);\n  width: 100%;\n  display: flex;\n  flex-direction: row-reverse;\n  padding: 8px 16px;\n"], ["\n  position: absolute;\n  top: calc(100% - ", "px);\n  width: 100%;\n  display: flex;\n  flex-direction: row-reverse;\n  padding: 8px 16px;\n"])), function (_a) {
    var endScene = _a.endScene;
    return (endScene ? 64 * 2 : 64);
});
exports.default = ReactionsFooter;
var templateObject_1;
